import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Calendar, Zap, TrendingUp } from 'lucide-react';

const PlugModal = ({ isOpen, onClose, friend, onSubmit }) => {
  const [plugData, setPlugData] = useState({
    started_using_date: '',
    times_used: 1
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!plugData.started_using_date) return;
    
    await onSubmit(plugData);
    
    // Reset form
    setPlugData({
      started_using_date: '',
      times_used: 1
    });
    
    onClose();
  };

  const handleInputChange = (field, value) => {
    setPlugData(prev => ({
      ...prev,
      [field]: field === 'times_used' ? parseInt(value) || 1 : value
    }));
  };

  if (!friend) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Zap className="w-5 h-5" style={{color: 'var(--brand-tan)'}} />
            Track Your Plug - {friend.name}
          </DialogTitle>
          <p className="text-sm text-gray-600 mt-2">
            Mark when you started using {friend.name}'s services and how often you've used them.
          </p>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="startDate" className="flex items-center gap-2">
              <Calendar className="w-4 h-4" />
              When did you start using their services? *
            </Label>
            <Input
              id="startDate"
              type="date"
              value={plugData.started_using_date}
              onChange={(e) => handleInputChange('started_using_date', e.target.value)}
              className="mt-1"
              max={new Date().toISOString().split('T')[0]}
              required
            />
          </div>

          <div>
            <Label htmlFor="timesUsed" className="flex items-center gap-2">
              <TrendingUp className="w-4 h-4" />
              How many times have you used their services?
            </Label>
            <Input
              id="timesUsed"
              type="number"
              min="1"
              value={plugData.times_used}
              onChange={(e) => handleInputChange('times_used', e.target.value)}
              className="mt-1"
              placeholder="e.g., 5"
            />
          </div>

          <div className="bg-gradient-to-r from-amber-50 to-amber-100 p-4 rounded-lg border border-amber-200">
            <div className="flex items-center gap-2 mb-2">
              <Zap className="w-5 h-5" style={{color: 'var(--brand-tan)'}} />
              <span className="font-medium" style={{color: 'var(--brand-navy)'}}>
                What's a "Plug"?
              </span>
            </div>
            <p className="text-sm" style={{color: 'var(--brand-navy)'}} className="opacity-80">
              Your "plug" is someone you regularly turn to for specific services. 
              Tracking this shows others how long you've trusted them as your go-to professional.
            </p>
          </div>

          <div className="flex gap-2 pt-2">
            <Button 
              type="button" 
              variant="outline" 
              onClick={onClose}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button 
              type="submit" 
              disabled={!plugData.started_using_date}
              className="flex-1 text-white"
              style={{
                background: 'linear-gradient(135deg, var(--brand-tan) 0%, var(--brand-tan-dark) 100%)'
              }}
            >
              Track Plug
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PlugModal;